// src/constants/userMutes.js
// Faz 1F Görev 4 — Kullanıcı sessize alma (mute) sözleşmesi.
//
// Block'un kardeşi; aynı pattern. Fark: mute TEK YÖNLÜ ve GİZLİ.
//   - Block  → karşı taraf bilir, takip kopar, interaksiyon durur.
//   - Mute   → karşı taraf bilmez, takip korunur, sadece İÇERİK gizlenir.
//
// Kullanım alanı: feed, yorumlar, bildirimler — muted uid'in ürettiği her
// şey görünmez olur. Write-side enforcement YOK (mute ≠ block).
//
// Tek kaynak; client service + hooks tarafından import edilir.
// Rule tarafı firestore.rules içinde ayrıca gate'lenir.

// Subcollection yolu: users/{muterUid}/{MUTE_SUBCOLLECTION}/{mutedUid}
export const MUTE_SUBCOLLECTION = "muted";

// Listeleme sınırları — block ile aynı cap.
export const MUTE_LIST_PAGE_SIZE = 500;

// Client cache TTL — block ile aynı pencere. Mute/unmute'ta invalidate
// edildiğinden 5 dk güvenli; tekrarlanan okumaları azaltır (maliyet).
export const MUTE_CACHE_TTL_MS = 300_000;
